// Updated by Vani 30th Sept 25 v1.0.2
import React, { useState, useRef, useEffect, forwardRef } from "react";
import { useScreenWidth } from "./useScreenWidth";
import "./style.css";
import { data } from "./data";
import { useNavigate } from "react-router-dom";
const Technologies = forwardRef((props, ref) => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const width = useScreenWidth();
  const navigate = useNavigate();
  const videoRefs = useRef([]);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);
  const showServiseDetail = (slug) => {
    navigate(`/service-details/${slug}`);
  };
  const isMobile = () => {
    const isSmallScreen = window.innerWidth <= 768;
    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return isSmallScreen || isMobileUA;
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(sectionRef.current); // run only once
        }
      },
      {
        threshold: isMobile() ? 0.05 : 0.2, // trigger when 1% for mobile and 20% of desktop section is visible
        rootMargin: "0px 0px -10% 0px", // trigger when 20% of section is visible
      }
    );
 
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
 
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
 
  const handleMouseEnter = async (id, index) => {
    setHoveredCard(id);
    const video = videoRefs.current[index];
    if (video) {
      try {
        video.currentTime = 0;
        await video.play();
      } catch (error) {
        // Suppress or log the play error
        console.warn("Video play interrupted or failed:", error);
      }
    }
  };
 
  const handleMouseLeave = (id, index) => {
    setHoveredCard(null);
    const video = videoRefs.current[index];
    if (video && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  };
 
  return (
    <div
      className="technology-section-wrapper"
      // ref={sectionRef}
      ref={(el) => {
        sectionRef.current = el;
        if (typeof ref === "function") {
          ref(el);
        } else if (ref) {
          ref.current = el;
        }
      }}
    >
      <div className="blurred-animation-container">
        <div className="blurred-moving-div"></div>
      </div>
      <div className="technology-container">
        <div>
          <p
            className={`technology-heading ${inView ? "animated-card delay-0" : ""
              }`}
          >
            THE THINGS WE ARE GOOD AT
          </p>
          <p
            className={`technology-desc ${inView ? "animated-card delay-card-1" : ""
              }`}
          >
            Technology is our tool. Experience is our art. Together, they
            create magic.
          </p>
        </div>
        <div className="technology-cards-container">
          {data.map((item, index) => {
            if (!videoRefs.current[index]) {
              videoRefs.current[index] = React.createRef();
            }
 
            return (
              <div
                onClick={() => showServiseDetail(item.slug)}
                key={item.id}
                className={`technology-card ${inView ? `animated-card delay-card-${index}` : ""
                  }`}
                onMouseEnter={() => handleMouseEnter(item.id, index)}
                onMouseLeave={() => handleMouseLeave(item.id, index)}
              >
                <video
                  className={`card-video ${hoveredCard === item.id ? "visible" : "hidden"
                    }`}
                  muted
                  loop
                  playsInline
                  ref={(el) => (videoRefs.current[index] = el)}
                >
                  <source src={item.video} type="video/mp4" />
                </video>
                <div className="card-desc">
                  {width <= 768
                    ? item.desc.length > 200
                      ? (
                        <>
                          {item.desc.substring(0, 200)}
                          <span className="know-more">...Know more</span>
                        </>
                      )
                      : item.desc
                    : item.desc.length > parseInt((width || 1200) / 10)
                      ? (
                        <>
                          {item.desc.substring(0, parseInt((width || 1200) / 10))}
                          <span className="know-more">...Know more</span>
                        </>
                      )
                      : item.desc}
                </div>
 
 
 
 
 
 
 
                <div className="technology-details">
                  {hoveredCard === item.id ? (
                    item.gifVideo ? (
                      <video
                        style={{
                          backgroundColor:
                            hoveredCard === item.id &&
                              (item.gif || item.gifVideo)
                              ? item.bgColor
                              : "transparent",
                        }}
                        className="technology-logo"
                        src={item.gifVideo}
                        autoPlay
                        loop
                        muted
                        playsInline
                      />
                    ) : (
                      <img
                        style={{
                          borderRadius: "50%",
                          backgroundColor:
                            hoveredCard === item.id &&
                              (item.gif || item.gifVideo)
                              ? item.bgColor
                              : "transparent",
                        }}
                        className="technology-logo"
                        src={item.gif}
                        alt="Technology GIF"
                      />
                    )
                  ) : (
                    <img
                      className="technology-logo"
                      src={item.image}
                      alt="Technology Logo"
                    />
                  )}
 
                  <p className="technology-name">{item.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
 
export default Technologies;
